__turbopack_context__.v({
  "container": "TruncatedRow-module__mt-jBG__container",
  "fixed": "TruncatedRow-module__mt-jBG__fixed",
  "truncated": "TruncatedRow-module__mt-jBG__truncated",
});
